import React from 'react';
import { shape, arrayOf, func, string, bool, number, oneOfType } from 'prop-types';
import Icon from 'components/icon';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import MultiCheckboxFilter from './multi-checkbox-filter/';
import SingleCheckboxFilter from './single-checkbox-filter/';
import DateRangeFilter from './date-range-filter/';
import DropdownFilter from './dropdown-filter/';
// import KeywordFilter from './keyword-filter/';
import * as FilterTypeConstants from '../constants/filter-types';
import { getActiveValues } from '../utils/active-filters';

export default class FiltersSection extends React.Component {
    constructor(props) {
        super(props);

        this.filtersOrder = [
            'MaterialType',
            'SiteName',
            'SiteForemanName',
            // 'SupplierTradingName',
            'StatusName',
            'keywords',
            'edocket',
            'Date Range'
        ];

        this.filtersOrderContractor = [
            'StatusName',
            'keywords',
            'edocket',
            'Date Range'
        ];

        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
        this.toggleCombineLoads = this.toggleCombineLoads.bind(this);
    }

    componentWillMount() {
        const newState = { ...this.state };
        const initialProps = { ...this.props };

        this.setState({
            ...newState,
            exportCombineLoads: initialProps.exportCombineLoads
        });
    }

    shouldComponentUpdate(newProps) {
        const changedFocusedFilter = (this.props.focusedFilter !== newProps.focusedFilter);
        const changedExportCombineLoads = (this.props.exportCombineLoads !== newProps.exportCombineLoads);
        const changedSearchFieldValue = (this.props.searchFieldValue !== newProps.searchFieldValue);
        return changedFocusedFilter || this.props.focusedFilter || changedExportCombineLoads || changedSearchFieldValue;
    }

    sortFilters(filtersList) {
        if (this.props.refType === 'contractor') {
            return this.filtersOrderContractor.map(filterName =>
                filtersList.find(filter => filter.queryParam === filterName));
        }

        return this.filtersOrder.map(filterName => filtersList.find(filter => filter.queryParam === filterName));
    }

    // handleKeyPress(e, eDocketSearch) {
    //     // Pass the input value back to the update call back function when enter is pressed
    //     if (e.key === 'Enter') {
    //         e.preventDefault(); // stops kentico page form from submitting
    //         this.handleClick(eDocketSearch);
    //     }
    // }

    // handleChange(e) {
    //     e.preventDefault();
    //     this.setState({ eDocketSearch: e.target.value });
    // }

    handleSearchInputChange(e) {
        e.preventDefault();
        // this.setState({ eDocketSearch: e.target.value });
        this.props.searchFieldChange(e.target.value);
    }

    // handleSearchInputKeyPress(e) {
    //     if (e.key === 'Enter') {
    //         // e.preventDefault(); // stops kentico page form from submitting
    //         // this.handleClick(eDocketSearch);
    //         this.props.searchFieldChange(e.target.value);
    //     }
    // }

    toggleCombineLoads() {
        const { exportCombineLoadToggle } = this.props;
        if (exportCombineLoadToggle) {
            exportCombineLoadToggle();
        }
    }

    render() {
        const isContractor = (this.props.refType === 'contractor');
        const sortedFilters = this.sortFilters(this.props.filters);
        const numberOfSortedFilter = sortedFilters.length + 1;
        // isContractor ? (sortedFilters.length + 1) : sortedFilters.length;
        const { exportCombineLoads, isLoading } = this.props;

        return (
            <div className="filters-section">
                <ReactCSSTransitionGroup
                    component="div"
                    className="active-filters"
                    transitionName="slide-in-out"
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={200}
                >
                    <div
                        className={`filters${isContractor ? ' filters-contractor' : ''}`}
                        style={{ '--filters-count': numberOfSortedFilter }}
                    >
                        <div className="edocket-search form-element">
                            <span className="filter-title">Filter by</span>
                            <div className="label-wrapper hidden">
                                <label htmlFor="eDocketSearch">eDocket number Search</label>
                            </div>
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    maxLength="25"
                                    id="eDocketSearch"
                                    value={this.props.searchFieldValue}
                                    onChange={this.handleSearchInputChange}
                                    placeholder={this.props.eDocketSearchPlaceholder}
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            this.props.searchButtonClick();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {sortedFilters.map(filter => {
                            const activeValues = getActiveValues(filter, this.props.activeFilters);
                            switch (filter && filter.type) {
                                case FilterTypeConstants.FILTER_TYPE_TAGS:
                                case FilterTypeConstants.FILTER_TYPE_MULTI_CHECKBOX:
                                    return (
                                        <MultiCheckboxFilter
                                            key={filter.code}
                                            filter={filter}
                                            selectedItems={activeValues}
                                            toggleFilters={this.props.toggleFilters}
                                            classModifier="filter-item"
                                            isFocused={this.props.focusedFilter === filter.code}
                                            toggleFocus={this.props.toggleFocus}
                                            resetFilters={this.props.resetFilterGroup}
                                        />
                                    );

                                case FilterTypeConstants.FILTER_TYPE_SINGLE_CHECKBOX:
                                    return (
                                        <SingleCheckboxFilter
                                            key={filter.code}
                                            filter={filter}
                                            isChecked={activeValues.length ?
                                                (filter.values[0] === activeValues[0]) : false}
                                            toggleFilters={this.props.toggleFilters}
                                            classModifier="filter-item"
                                        />
                                    );

                                case FilterTypeConstants.FILTER_TYPE_DROPDOWN:
                                    return (
                                        <DropdownFilter
                                            key={filter.code}
                                            filter={filter}
                                            selectedItems={activeValues}
                                            toggleFilters={this.props.toggleFilters}
                                            classModifier="filter-item"
                                            isFocused={this.props.focusedFilter === filter.code}
                                            toggleFocus={this.props.toggleFocus}
                                        />
                                    );

                                case FilterTypeConstants.FILTER_TYPE_DATERANGE:
                                    return (
                                        <DateRangeFilter
                                            key={filter.code}
                                            label={filter.label}
                                            classModifier="filter-item"
                                            minDate={this.props.minDate}
                                            maxDate={this.props.maxDate}
                                            fetchData={this.props.fetchData}
                                            startDate={this.props.startDate}
                                            endDate={this.props.endDate}
                                            dateUpdate={this.props.dateUpdate}
                                        />
                                    );

                                // case FilterTypeConstants.FILTER_TYPE_KEYWORDS: {
                                //     let placeholder = 'Enter keywords';
                                //     if (this.props.filterSettings.keywordPlaceholderText) {
                                //         placeholder = this.props.filterSettings.keywordPlaceholderText;
                                //     }
                                //     return (
                                //         <KeywordFilter
                                //             key={filter.code}
                                //             filter={filter}
                                //             keyword={activeValues.length ? activeValues[0] : ''}
                                //             updateKeyword={this.props.toggleFilters}
                                //             placeholderText={placeholder}
                                //             classModifier="filter-item filter-item-keyword"
                                //             resetFilters={this.props.resetFilterGroup}
                                //         />
                                //     );
                                // }

                                default:
                                    return null;
                            }
                        })}

                        <div className="filter-action-container">
                            <div className="filter-action-buttons">
                                <button
                                    className="btn-skin-3 apply-button"
                                    onClick={e => {
                                        e.preventDefault();
                                        this.props.searchButtonClick();
                                    }}
                                >
                                    <Icon glyph="search" />
                                    <span className="button-text">Apply</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    {!isLoading && this.props.itemCount > 0 && (
                        <div className="filter-export-group-class">
                            <div className="export-group-class">
                                <button className="btn-skin-3 export-button" onClick={() => this.props.handleExport()}>
                                    <Icon glyph="download" />
                                    <span className="button-text">{this.props.exportText}</span>
                                </button>
                                <input type="checkbox" id="exportCombineLoad" className="export-combine-toggle" name="combineLoad" onChange={() => this.toggleCombineLoads()} checked={exportCombineLoads} />
                                <label htmlFor="exportCombineLoad" className="export-combine-label">Combine Load Data</label>
                            </div>
                        </div>
                    )}
                </ReactCSSTransitionGroup>
            </div>
        );
    }
}

FiltersSection.propTypes = {
    filters: arrayOf(shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number]))
    })).isRequired,
    // filterSettings: shape({
    //     itemsPerPage: number,
    //     showResultCount: bool,
    //     showActiveFilters: bool,
    //     activeFiltersStyle: string,
    //     activeFiltersLabel: string,
    //     keywordPlaceholderText: string,
    //     keywordSearchableFields: arrayOf(string),
    //     sortBy: arrayOf(object)
    // }).isRequired,
    activeFilters: arrayOf(shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number])).isRequired
    })).isRequired,
    focusedFilter: string,
    toggleFilters: func.isRequired,
    toggleFocus: func.isRequired,
    minDate: number.isRequired,
    maxDate: number.isRequired,
    fetchData: func.isRequired,
    startDate: number.isRequired,
    endDate: number.isRequired,
    resetFilterGroup: func.isRequired,
    eDocketSearchPlaceholder: string,
    dateUpdate: func,
    searchButtonClick: func,
    itemCount: number,
    handleExport: func,
    exportText: string,
    exportCombineLoads: bool,
    searchFieldValue: string,
    searchFieldChange: func,
    exportCombineLoadToggle: func,
    refType: string.isRequired,
    isLoading: bool
};

FiltersSection.defaultProps = {
    focusedFilter: null,
    eDocketSearchPlaceholder: '',
    dateUpdate: null,
    searchButtonClick: null,
    itemCount: 0,
    handleExport: null,
    exportText: 'Export',
    exportCombineLoads: true,
    searchFieldValue: '',
    searchFieldChange: null,
    exportCombineLoadToggle: null,
    isLoading: false
};
